import * as React from 'react';
import { ConfigAndDataContext } from '@/state/context/ConfigAndDataContext';
import Toast from '../../objects/Toast';
import { useContext, useEffect, useState } from 'react';
import ExportDialog from '@/components/avgrensning/vegnett/ExportDialog';
import { useVegnettUrls } from '@/utils/exportUtils';
import { ApiVersion } from '@/state';
import { getApiVersion } from '@/utils/Utils';

export const DownloadResultsBox = () => {
    const { restapi_url, restapi_url_v3, eksport_url } = useContext(ConfigAndDataContext).config;
    const rest_api_url = getApiVersion() === ApiVersion.V3 ? restapi_url_v3 : restapi_url;
    const { json } = useVegnettUrls(rest_api_url, eksport_url);
    const [downloading, setDownloading] = useState(false);

    const [exportDialogOpen, setExportDialogOpen] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState('');

    useEffect(() => {
        if (!downloading) return;
        const timeout = setTimeout(() => {
            setDownloading(false);
        }, 5000);
        return () => {
            clearTimeout(timeout);
        };
    }, [downloading]);

    return (
        <div className="c-results-summary t-hidden-mobile">
            <div className="c-results-summary__export c-results-summary-export">
                <div className="c-results-summary-export__links c-results-summary-export-links t-clearfix">
                    <a href={downloadUrl} onClick={() => setDownloading(true)}>
                        <i className="o-icon-download c-results-summary__icon-download" aria-hidden={true} />
                    </a>
                    <label className="c-results-summary__text">Last ned datasett:</label>
                    <a
                        id="eksport-link"
                        key="eksport-link"
                        className="c-results-summary-export-dialog"
                        onClick={() => setExportDialogOpen(true)}
                        style={{ cursor: 'pointer' }}
                    >
                        Eksporter{' '}
                    </a>
                    <a
                        key="api-link"
                        className="c-results-summary-export-links__api"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={json}
                    >
                        API
                    </a>
                </div>
            </div>
            <Toast text={'Nedlasting startet ...'} show={downloading} />
            <ExportDialog
                isOpen={exportDialogOpen}
                setIsOpen={setExportDialogOpen}
                setDownloading={setDownloading}
                setDownloadUrl={setDownloadUrl}
            />
        </div>
    );
};
